import React from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import * as Routes from '../../../../constants/routes';
import InfoBox from '../../../../common/components/info-box';
import SummaryForm from '../../components/forms/summary';

const scheduleButton = {
    link: `${process.env.PUBLIC_URL}/loan${Routes.SCHEDULE}`,
    label: 'View your payment schedule'
};

const ctaButton = {
    link: `${process.env.PUBLIC_URL}/loan${Routes.CONTACT}`,
    label: 'Start planning your loan today'
};

const backButton = {
    link: `${process.env.PUBLIC_URL}/loan${Routes.STEPFIVE}`,
    label: 'Go back to make changes'
};

const tooltip = {
    title: 'Did you know?',
    content: 'Insight about Loans.',
    button: ctaButton
};

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Here’s your Personal Loan Summary</h1>
        <p className={styles.summary}>Based on your selections, your estimated loan payment would be <strong>$350 per month</strong>.</p>
        <Link
            to={scheduleButton.link}
            className={styles.ctaButton}
            title={scheduleButton.label}
        >
            {scheduleButton.label}
        </Link>
        <Link
            to={backButton.link}
            className={styles.outlineButton}
            title={backButton.label}
        >
            {backButton.label}
        </Link>
        <SummaryForm/>
        <InfoBox
            title={tooltip.title}
            content={tooltip.content}
            button={tooltip.button}
        />
    </div>
);
